import { motion } from "framer-motion";
import { Activity, ArrowDown, Move3d } from "lucide-react";

export function HeroOrbit() {
  return (
    <>
      <motion.div
        className="orbit-badge"
        animate={{ rotate: 360 }}
        transition={{ duration: 24, repeat: Infinity, ease: "linear" }}
        aria-hidden="true"
      >
        <svg viewBox="0 0 160 160" role="img">
          <defs>
            <path id="hero-orbit-path" d="M80,80 m-58,0 a58,58 0 1,1 116,0 a58,58 0 1,1 -116,0" />
          </defs>
          <text>
            <textPath href="#hero-orbit-path">MOVE BETTER • WORK WITHOUT PAIN • FIX METHOD •</textPath>
          </text>
        </svg>
        <span>FIX</span>
      </motion.div>
      <motion.div
        className="pain-chip pain-chip-primary"
        animate={{ y: [0, -12, 0] }}
        transition={{ duration: 4.6, repeat: Infinity, ease: "easeInOut" }}
      >
        <Activity size={13} /> Neck + back
      </motion.div>
      <motion.div
        className="pain-chip pain-chip-secondary"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 5.2, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
      >
        <Move3d size={13} /> Posture + mobility
      </motion.div>
    </>
  );
}

export function ScrollCue({ onClick }) {
  return (
    <motion.button
      type="button"
      className="scroll-cue"
      onClick={onClick}
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 1.05 }}
      data-testid="hero-scroll-cue"
    >
      <span><ArrowDown size={14} /></span>
      Scroll to begin
    </motion.button>
  );
}
